import { Badge } from '@/components/ui/Badge';
import type { WardRequestPriority, WardRequestStatus } from './api';

const STATUS: Record<WardRequestStatus, { label: string; variant: 'info' | 'warn' | 'success' | 'neutral' }> = {
  requested: { label: 'Waiting at pharmacy', variant: 'info' },
  dispensed: { label: 'Ready to collect', variant: 'warn' },
  collected: { label: 'Handed over', variant: 'success' },
  cancelled: { label: 'Cancelled', variant: 'neutral' },
};

export function WardRequestStatusBadge({ status }: { status: WardRequestStatus }) {
  return <Badge variant={STATUS[status].variant}>{STATUS[status].label}</Badge>;
}

export function PriorityBadge({ priority }: { priority: WardRequestPriority }) {
  if (priority === 'routine') return null;
  return <Badge variant="danger">{priority === 'stat' ? 'STAT' : 'Urgent'}</Badge>;
}

export const PRIORITY_OPTIONS: Array<{ value: WardRequestPriority; label: string }> = [
  { value: 'routine', label: 'Routine' },
  { value: 'urgent', label: 'Urgent' },
  { value: 'stat', label: 'STAT' },
];
